<template>
    <a type="button" @click="sendToParent"
    ><i class="fa fa-times-circle table-action-2-delete"></i
    ></a>
</template>

<script>
    export default {
        name: 'TableDeleteElement',
        props: {
            id: Number,
            element: Object
        },
        methods:{
            sendToParent(){
                this.$emit('method', this.id, this.element);
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
